import SolImg from "../assets/images/sol.png";
import USDTImg from "../assets/images/usdt.png";
import BTCImg from "../assets/images/btc.png";
import ETHImg from "../assets/images/eth.png";
import SOLARImg from "../assets/images/solar.png";
import SOLCHImg from "../assets/images/solch.png";
import USDCImg from "../assets/images/usdc.png";
import ZEBECImg from "../assets/images/zebec.png";
import { BiEuro, BiDollar } from "react-icons/bi";

export const CRYPTO_VALUES = [{
    img: SolImg,
    title: "SOL",
    value: "sol"
}, {
    img: USDCImg,
    title: "USDC",
    value: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v"
    // value: "E9UURnky9iZ8HuazYZ7JXjUMxT27B1JKVxcZW2AoDCHw"
}, {
    img: USDTImg,
    title: "USDT",
    value: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB"
}, {
    img: ETHImg,
    title: "WETH",
    value: "2FPyTwcZLUg1MDrwsyoP4D6s1tM7hAkHYRjkNb5w6Pxk"
}, {
    img: BTCImg,
    title: "WBTC",
    value: "9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E"
}, {
    img: SOLARImg,
    title: "SOLAR",
    value: "2wmKXX1xsxLfrvjEPrt2UHiqj8Gbzwxvffr9qmNjsw8g"
}, {
    img: SOLCHImg,
    title: "SOLCH",
    value: "EKSM2sjtptnvkqq79kwfAaSfVudNAtFYZSBdPe5jeRSt"
}, {
    img: ZEBECImg,
    title: "ZEBEC",
    value: "zebeczgi5fSEtbpfQKVZKCJ3WgYXxjkMUkNNx7fLKAF"
}];

export const CRYPTO_FILTER_VALUES = [{
    title: "All",
    value: ""
}, {
    img: SolImg,
    title: "SOL",
    value: "sol"
}, {
    img: USDCImg,
    title: "USDC",
    value: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v"
    // value: "E9UURnky9iZ8HuazYZ7JXjUMxT27B1JKVxcZW2AoDCHw"
}, {
    img: USDTImg,
    title: "USDT",
    value: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB"
}, {
    img: ETHImg,
    title: "WETH",
    value: "2FPyTwcZLUg1MDrwsyoP4D6s1tM7hAkHYRjkNb5w6Pxk"
}, {
    img: BTCImg,
    title: "WBTC",
    value: "9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E"
}, {
    img: SOLARImg,
    title: "SOLAR",
    value: "2wmKXX1xsxLfrvjEPrt2UHiqj8Gbzwxvffr9qmNjsw8g"
}, {
    img: SOLCHImg,
    title: "SOLCH",
    value: "EKSM2sjtptnvkqq79kwfAaSfVudNAtFYZSBdPe5jeRSt"
}, {
    img: ZEBECImg,
    title: "ZEBEC",
    value: "zebeczgi5fSEtbpfQKVZKCJ3WgYXxjkMUkNNx7fLKAF"
}];

export const FIAT_VALUES = [{
    title: "AED",
    value: "aed",
    price: 1,
    sign: ""
},{
    title: "AFN",
    value: "afn",
    price: 1,
    sign: ""
},{
    title: "AMD",
    value: "amd",
    price: 1,
    sign: ""
},{
    title: "ARS",
    value: "ars",
    price: 1,
    sign: ""
},{
    title: "AUD",
    value: "aud",
    price: 1,
    sign: ""
},{
    title: "AZN",
    value: "azn",
    price: 1,
    sign: ""
},{
    title: "BDT",
    value: "bdt",
    price: 1,
    sign: ""
},{
    title: "BGN",
    value: "bgn",
    price: 1,
    sign: ""
},{
    title: "BHD",
    value: "bhd",
    price: 1,
    sign: ""
},{
    title: "BOB",
    value: "bob",
    price: 1,
    sign: ""
},{
    title: "BRL",
    value: "brl",
    price: 1,
    sign: ""
},{
    title: "BYN",
    value: "byn",
    price: 1,
    sign: ""
},{
    title: "CAD",
    value: "cad",
    price: 1,
    sign: ""
},{
    title: "CDF",
    value: "cdf",
    price: 1,
    sign: ""
},{
    title: "CHF",
    value: "chf",
    price: 1,
    sign: ""
},{
    title: "CLP",
    value: "clp",
    price: 1,
    sign: ""
},{
    title: "CNY",
    value: "cny",
    price: 1,
    sign: ""
},{
    title: "COP",
    value: "cop",
    price: 1,
    sign: ""
},{
    title: "CRC",
    value: "crc",
    price: 1,
    sign: ""
},{
    title: "CZK",
    value: "czk",
    price: 1,
    sign: ""
},{
    title: "DJF",
    value: "djf",
    price: 1,
    sign: ""
},{
    title: "DKK",
    value: "dkk",
    price: 1,
    sign: ""
},{
    title: "DOP",
    value: "dop",
    price: 1,
    sign: ""
},{
    title: "DZD",
    value: "dzd",
    price: 1,
    sign: ""
},{
    title: "EGP",
    value: "egp",
    price: 1,
    sign: ""
},{
    title: "ERN",
    value: "ern",
    price: 1,
    sign: ""
},{
    title: "ETB",
    value: "etb",
    price: 1,
    sign: ""
},{
    title: "EUR",
    value: "eur",
    price: 1.02,
    sign: <BiEuro size={18} />
},{
    title: "GBP",
    value: "gbp",
    price: 1,
    sign: ""
},{
    title: "GEL",
    value: "gel",
    price: 1,
    sign: ""
},{
    title: "GHS",
    value: "ghs",
    price: 1,
    sign: ""
},{
    title: "GNF",
    value: "gnf",
    price: 1,
    sign: ""
},{
    title: "GTQ",
    value: "gtq",
    price: 1,
    sign: ""
},{
    title: "HKD",
    value: "hkd",
    price: 1,
    sign: ""
},{
    title: "HRK",
    value: "hrk",
    price: 1,
    sign: ""
},{
    title: "HUF",
    value: "huf",
    price: 1,
    sign: ""
},{
    title: "IDR",
    value: "idr",
    price: 1,
    sign: ""
},{
    title: "INR",
    value: "inr",
    price: 1,
    sign: ""
},{
    title: "ISK",
    value: "isk",
    price: 1,
    sign: ""
},{
    title: "JOD",
    value: "jod",
    price: 1,
    sign: ""
},{
    title: "JPY",
    value: "jpy",
    price: 1,
    sign: ""
},{
    title: "KES",
    value: "kes",
    price: 1,
    sign: ""
},{
    title: "KGS",
    value: "kgs",
    price: 1,
    sign: ""
},{
    title: "KHR",
    value: "khr",
    price: 1,
    sign: ""
},{
    title: "KMF",
    value: "kmf",
    price: 1,
    sign: ""
},{
    title: "KWD",
    value: "kwd",
    price: 1,
    sign: ""
},{
    title: "KZT",
    value: "kzt",
    price: 1,
    sign: ""
},{
    title: "LAK",
    value: "lak",
    price: 1,
    sign: ""
},{
    title: "LKR",
    value: "lkr",
    price: 1,
    sign: ""
},{
    title: "MAD",
    value: "mad",
    price: 1,
    sign: ""
},{
    title: "MDL",
    value: "mdl",
    price: 1,
    sign: ""
},{
    title: "MGA",
    value: "mga",
    price: 1,
    sign: ""
},{
    title: "MMK",
    value: "mmk",
    price: 1,
    sign: ""
},{
    title: "MNT",
    value: "mnt",
    price: 1,
    sign: ""
},{
    title: "MOP",
    value: "mop",
    price: 1,
    sign: ""
},{
    title: "MXN",
    value: "mxn",
    price: 1,
    sign: ""
},{
    title: "NGN",
    value: "ngn",
    price: 1,
    sign: ""
},{
    title: "NIO",
    value: "nio",
    price: 1,
    sign: ""
},{
    title: "NOK",
    value: "nok",
    price: 1,
    sign: ""
},{
    title: "NPR",
    value: "npr",
    price: 1,
    sign: ""
},{
    title: "NZD",
    value: "nzd",
    price: 1,
    sign: ""
},{
    title: "OMR",
    value: "omr",
    price: 1,
    sign: ""
},{
    title: "PAB",
    value: "pab",
    price: 1,
    sign: ""
},{
    title: "PEN",
    value: "pen",
    price: 1,
    sign: ""
},{
    title: "PGK",
    value: "pgk",
    price: 1,
    sign: ""
},{
    title: "PHP",
    value: "php",
    price: 1,
    sign: ""
},{
    title: "PKR",
    value: "pkr",
    price: 1,
    sign: ""
},{
    title: "PLN",
    value: "pln",
    price: 1,
    sign: ""
},{
    title: "PYG",
    value: "pyg",
    price: 1,
    sign: ""
},{
    title: "QAR",
    value: "qar",
    price: 1,
    sign: ""
},{
    title: "RON",
    value: "ron",
    price: 1,
    sign: ""
},{
    title: "RSD",
    value: "rsd",
    price: 1,
    sign: ""
},{
    title: "RWF",
    value: "rwf",
    price: 1,
    sign: ""
},{
    title: "SAR",
    value: "sar",
    price: 1,
    sign: ""
},{
    title: "SCR",
    value: "scr",
    price: 1,
    sign: ""
},{
    title: "SEK",
    value: "sek",
    price: 1,
    sign: ""
},{
    title: "THB",
    value: "thb",
    price: 1,
    sign: ""
},{
    title: "TJS",
    value: "tjs",
    price: 1,
    sign: ""
},{
    title: "TMT",
    value: "tmt",
    price: 1,
    sign: ""
},{
    title: "TND",
    value: "tnd",
    price: 1,
    sign: ""
},{
    title: "TRY",
    value: "try",
    price: 1,
    sign: ""
},{
    title: "TWD",
    value: "twd",
    price: 1,
    sign: ""
},{
    title: "TZS",
    value: "tzs",
    price: 1,
    sign: ""
},{
    title: "UAH",
    value: "uah",
    price: 1,
    sign: ""
},{
    title: "UGX",
    value: "ugx",
    price: 1,
    sign: ""
},{
    title: "USD",
    value: "usd",
    price: 1,
    sign: <BiDollar size={18} />
},{
    title: "UYU",
    value: "uyu",
    price: 1,
    sign: ""
},{
    title: "UZA",
    value: "uzs",
    price: 1,
    sign: ""
},{
    title: "VND",
    value: "vnd",
    price: 1,
    sign: ""
},{
    title: "XAF",
    value: "xaf",
    price: 1,
    sign: ""
},{
    title: "XOF",
    value: "xof",
    price: 1,
    sign: ""
},{
    title: "YER",
    value: "yer",
    price: 1,
    sign: ""
},{
    title: "ZAR",
    value: "zar",
    price: 1,
    sign: ""
}];

export const FIAT_FILTER_VALUES = [{
    title: "All",
    value: ""
},{
    title: "AED",
    value: "aed",

},{
    title: "AFN",
    value: "afn",

},{
    title: "AMD",
    value: "amd",

},{
    title: "ARS",
    value: "ars",

},{
    title: "AUD",
    value: "aud",

},{
    title: "AZN",
    value: "azn",

},{
    title: "BDT",
    value: "bdt",

},{
    title: "BGN",
    value: "bgn",

},{
    title: "BHD",
    value: "bhd",

},{
    title: "BOB",
    value: "bob",

},{
    title: "BRL",
    value: "brl",

},{
    title: "BYN",
    value: "byn",

},{
    title: "CAD",
    value: "cad",

},{
    title: "CDF",
    value: "cdf",

},{
    title: "CHF",
    value: "chf",

},{
    title: "CLP",
    value: "clp",

},{
    title: "CNY",
    value: "cny",

},{
    title: "COP",
    value: "cop",

},{
    title: "CRC",
    value: "crc",

},{
    title: "CZK",
    value: "czk",

},{
    title: "DJF",
    value: "djf",

},{
    title: "DKK",
    value: "dkk",

},{
    title: "DOP",
    value: "dop",

},{
    title: "DZD",
    value: "dzd",

},{
    title: "EGP",
    value: "egp",

},{
    title: "ERN",
    value: "ern",

},{
    title: "ETB",
    value: "etb",

},{
    title: "EUR",
    value: "eur",

},{
    title: "GBP",
    value: "gbp",

},{
    title: "GEL",
    value: "gel",

},{
    title: "GHS",
    value: "ghs",

},{
    title: "GNF",
    value: "gnf",

},{
    title: "GTQ",
    value: "gtq",

},{
    title: "HKD",
    value: "hkd",

},{
    title: "HRK",
    value: "hrk",

},{
    title: "HUF",
    value: "huf",

},{
    title: "IDR",
    value: "idr",

},{
    title: "INR",
    value: "inr",

},{
    title: "ISK",
    value: "isk",

},{
    title: "JOD",
    value: "jod",

},{
    title: "JPY",
    value: "jpy",

},{
    title: "KES",
    value: "kes",

},{
    title: "KGS",
    value: "kgs",

},{
    title: "KHR",
    value: "khr",

},{
    title: "KMF",
    value: "kmf",

},{
    title: "KWD",
    value: "kwd",

},{
    title: "KZT",
    value: "kzt",

},{
    title: "LAK",
    value: "lak",

},{
    title: "LKR",
    value: "lkr",

},{
    title: "MAD",
    value: "mad",

},{
    title: "MDL",
    value: "mdl",

},{
    title: "MGA",
    value: "mga",

},{
    title: "MMK",
    value: "mmk",

},{
    title: "MNT",
    value: "mnt",

},{
    title: "MOP",
    value: "mop",

},{
    title: "MXN",
    value: "mxn",

},{
    title: "NGN",
    value: "ngn",

},{
    title: "NIO",
    value: "nio",

},{
    title: "NOK",
    value: "nok",

},{
    title: "NPR",
    value: "npr",

},{
    title: "NZD",
    value: "nzd",

},{
    title: "OMR",
    value: "omr",

},{
    title: "PAB",
    value: "pab",

},{
    title: "PEN",
    value: "pen",

},{
    title: "PGK",
    value: "pgk",

},{
    title: "PHP",
    value: "php",

},{
    title: "PKR",
    value: "pkr",

},{
    title: "PLN",
    value: "pln",

},{
    title: "PYG",
    value: "pyg",

},{
    title: "QAR",
    value: "qar",

},{
    title: "RON",
    value: "ron",

},{
    title: "RSD",
    value: "rsd",

},{
    title: "RWF",
    value: "rwf",

},{
    title: "SAR",
    value: "sar",

},{
    title: "SCR",
    value: "scr",

},{
    title: "SEK",
    value: "sek",

},{
    title: "THB",
    value: "thb",

},{
    title: "TJS",
    value: "tjs",

},{
    title: "TMT",
    value: "tmt",

},{
    title: "TND",
    value: "tnd",

},{
    title: "TRY",
    value: "try",

},{
    title: "TWD",
    value: "twd",

},{
    title: "TZS",
    value: "tzs",

},{
    title: "UAH",
    value: "uah",

},{
    title: "UGX",
    value: "ugx",

},{
    title: "USD",
    value: "usd",

},{
    title: "UYU",
    value: "uyu",

},{
    title: "UZA",
    value: "uzs",

},{
    title: "VND",
    value: "vnd",

},{
    title: "XAF",
    value: "xaf",

},{
    title: "XOF",
    value: "xof",

},{
    title: "YER",
    value: "yer",

},{
    title: "ZAR",
    value: "zar",

}];

export const PAYMENT_VALUES = [{
    title: "All payments",
    value: -1
}, {
    title: "Alipay",
    value: 0
}, {
    title: "Alipayhk",
    value: 1
}, {
    title: "Amazon pay",
    value: 2
}, {
    title: "Apple pay",
    value: 3
}, {
    title: "Bancontact",
    value: 4
}, {
    title: "Bank Of America",
    value: 5
}, {
    title: "Boost wallet",
    value: 6
}, {
    title: "Cash app",
    value: 7
}, {
    title: "Chase quick pay",
    value: 8
}, {
    title: "Chime Instant Transfer",
    value: 9
}, {
    title: "Chipper Cash",
    value: 10
}, {
    title: "Dana",
    value: 11
}, {
    title: "Dash app",
    value: 12
}, {
    title: "Doku wallet",
    value: 13
}, {
    title: "G-cash",
    value: 14
}, {
    title: "Google pay",
    value: 15
}, {
    title: "Go pay",
    value: 16
}, {
    title: "Grabpay",
    value: 17
}, {
    title: "Kakaopay",
    value: 18
}, {
    title: "M-Pesa",
    value: 19
}, {
    title: "MB Way",
    value: 20
}, {
    title: "MoMo",
    value: 21
}, {
    title: "MTN Mobile payment",
    value: 22
}, {
    title: "Orange Money",
    value: 23
}, {
    title: "Payco",
    value: 24
}, {
    title: "Payoneer",
    value: 25
}, {
    title: "Rapid Transfer",
    value: 26
}, {
    title: "Remitly",
    value: 27
}, {
    title: "Samsung pay",
    value: 28
}, {
    title: "Send Wave Wallet",
    value: 29
}, {
    title: "Sofi Money Instant Tranfer",
    value: 30
}, {
    title: "Stripe",
    value: 31
}, {
    title: "Touch'n Go Digital",
    value: 32
}, {
    title: "Transfer Go",
    value: 33
}, {
    title: "True Money",
    value: 34
}, {
    title: "Venmo",
    value: 35
}, {
    title: "Wechat",
    value: 36
}, {
    title: "Wise Transfer",
    value: 37
}, {
    title: "Zelle",
    value: 38
}];

export const PAYMENT_OFFER_VALUES = [{
    title: "Alipay",
    value: 0
}, {
    title: "Alipayhk",
    value: 1
}, {
    title: "Amazon pay",
    value: 2
}, {
    title: "Apple pay",
    value: 3
}, {
    title: "Bancontact",
    value: 4
}, {
    title: "Bank Of America",
    value: 5
}, {
    title: "Boost wallet",
    value: 6
}, {
    title: "Cash app",
    value: 7
}, {
    title: "Chase quick pay",
    value: 8
}, {
    title: "Chime Instant Transfer",
    value: 9
}, {
    title: "Chipper Cash",
    value: 10
}, {
    title: "Dana",
    value: 11
}, {
    title: "Dash app",
    value: 12
}, {
    title: "Doku wallet",
    value: 13
}, {
    title: "G-cash",
    value: 14
}, {
    title: "Google pay",
    value: 15
}, {
    title: "Go pay",
    value: 16
}, {
    title: "Grabpay",
    value: 17
}, {
    title: "Kakaopay",
    value: 18
}, {
    title: "M-Pesa",
    value: 19
}, {
    title: "MB Way",
    value: 20
}, {
    title: "MoMo",
    value: 21
}, {
    title: "MTN Mobile payment",
    value: 22
}, {
    title: "Orange Money",
    value: 23
}, {
    title: "Payco",
    value: 24
}, {
    title: "Payoneer",
    value: 25
}, {
    title: "Rapid Transfer",
    value: 26
}, {
    title: "Remitly",
    value: 27
}, {
    title: "Samsung pay",
    value: 28
}, {
    title: "Send Wave Wallet",
    value: 29
}, {
    title: "Sofi Money Instant Tranfer",
    value: 30
}, {
    title: "Stripe",
    value: 31
}, {
    title: "Touch'n Go Digital",
    value: 32
}, {
    title: "Transfer Go",
    value: 33
}, {
    title: "True Money",
    value: 34
}, {
    title: "Venmo",
    value: 35
}, {
    title: "Wechat",
    value: 36
}, {
    title: "Wise Transfer",
    value: 37
}, {
    title: "Zelle",
    value: 38
}];

export const TIME_VALUES = [{
    title: "10 min",
    value: 10
},{
    title: "20 min",
    value: 20
}, {
    title: "30 min",
    value: 30
}];

export const STATUS_VALUES = [{
    title: "All",
    value: ""
},{
    title: "Active",
    value: true
}, {
    title: "Discontinued",
    value: false
}];

export const REGION_VALUES = [{
    title: "All region",
    value: -1
},{
    title: "Canada",
    value: 0
},{
    title: "China (中国)",
    value: 1
}, {
    title: "Ghana (Gaana)",
    value: 2
}, {
    title: "Japan (日本)",
    value: 3
}, {
    title: "Kenya",
    value: 4
}, {
    title: "Nigeria",
    value: 5
}, {
    title: "Saudi Arabia (‫المملكة العربية السعودية‬‎)",
    value: 6
}, {
    title: "Singapore",
    value: 7
}, {
    title: "South Africa",
    value: 8
}, {
    title: "Spain (España)",
    value: 9
}, {
    title: "Taiwan (台灣)",
    value: 10
}, {
    title: "Tanzania",
    value: 11
}, {
    title: "Uganda",
    value: 12
}, {
    title: "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)",
    value: 13
}, {
    title: "United Kingdom",
    value: 14
}, {
    title: "United States",
    value: 15
}, {
    title: "Vietnam (Việt Nam)",
    value: 16
}, {
    title: "Yemen (‫اليمن‬‎)",
    value: 17
}, {
    title: "Zimbabwe",
    value: 18
}]